angular
    .module('AutoPrequal')
    .controller('birthdayYearCtrl', birthdayYearCtrl);

birthdayYearCtrl.$inject = ['$scope', '$rootScope', '$timeout', 'DataFactory', 'ScrollFactory'];

function birthdayYearCtrl($scope, $rootScope, $timeout, DataFactory, ScrollFactory) {

    $rootScope.progressCurrent = 6;
    $rootScope.progressMobCurrent = 6;

    $scope.content = DataFactory.appData.content;
    $scope.localContent = DataFactory.appData.content.birthday;
    $scope.data = DataFactory.appData.applicant;
    $scope.goToStep = ScrollFactory.goToStep;

    $scope.birthMM = DataFactory.appData.applicant.apBirthDateMM;
    $scope.birthMonth = $scope.content.month_list_full[$scope.birthMM];
    $scope.birthDay = DataFactory.appData.applicant.apBirthDateDD;

    $scope.selectedYear = DataFactory.appData.applicant.apBirthDateYYYY || "";
    DataFactory.appData.applicant.apBirthDateYYYY = $scope.selectedYear;
    $rootScope.continueDisabled = $scope.selectedYear === "" ? true : false;

    $scope.$watch(function () {
        return DataFactory.appData.applicant.apBirthDateYYYY
    }, function (newValue, oldValue) {
        if (newValue) $scope.selectedYear = newValue;
    })

    $scope.$watch(function () {
        return DataFactory.appData.applicant.apBirthDateMM
    }, function (newVal) {
        if (newVal) {
            $scope.birthMM = newVal;
			$scope.birthMonth = $scope.content.month_list_full[newVal];
            $scope.data.apBirthDate = DataFactory.appData.applicant.apBirthDateYYYY + '-' + ("00" + DataFactory.appData.applicant.apBirthDateMM).slice(-2) + '-' + ("00" + DataFactory.appData.applicant.apBirthDateDD).slice(-2);
			$rootScope.age = calculateAge($scope.data.apBirthDate);
		}
    });

    $scope.$watch(function () {
        return DataFactory.appData.applicant.apBirthDateDD
    }, function (newVal) {
        if (newVal) {
			$scope.birthDay = newVal;
            $scope.data.apBirthDate = DataFactory.appData.applicant.apBirthDateYYYY + '-' + ("00" + DataFactory.appData.applicant.apBirthDateMM).slice(-2) + '-' + ("00" + DataFactory.appData.applicant.apBirthDateDD).slice(-2);
			$rootScope.age = calculateAge($scope.data.apBirthDate);
		}
	});

	$scope.$watch(function () {
		return DataFactory.appData.applicant.apProvince
	}, function (newVal, oldVal) {
		if (newVal !== oldVal) checkAgeOfMajority();
	});

	$rootScope.$watch('age', function (newVal, oldVal) {
		if (newVal !== oldVal) checkAgeOfMajority();
	})

    $rootScope.$watch('currentStep', function (newVal) {
		if (newVal && newVal === "birthdayYear" && $scope.selectedYear) {
			$rootScope.continueDisabled = false;
		}
    })

    $scope.yearPrefix = ["190", "191", "192", "193", "194", "195", "196", "197", "198", "199", "200", "201"];


    //show decade by user selection
    if ($scope.selectedYear && $scope.selectedYear != "") {
        var dec = parseInt(($scope.selectedYear + "").charAt(2));
        if (dec == 0) $scope.currentDecadeIndex = 10;
        else $scope.currentDecadeIndex = dec;
    }
    else {
        $scope.currentDecadeIndex = 8;
    }

    $scope.nextStep = function (year) {
		if (year) $scope.data.apBirthDateYYYY = year;
		$scope.data.apBirthDate = $scope.data.apBirthDateYYYY + '-' + ("00" + DataFactory.appData.applicant.apBirthDateMM).slice(-2) + '-' + ("00" + DataFactory.appData.applicant.apBirthDateDD).slice(-2);
		$rootScope.age = calculateAge($scope.data.apBirthDate);
		if (checkAgeOfMajority()) {
			DataFactory.appData.applicant.appState.birthdayYear = true;
			DataFactory.setData($scope.data);
			ScrollFactory.showStep("applicantIncome");
			ScrollFactory.goToStep("applicantIncome");
		}
    }

    $rootScope.birthdayYearNextStep = function () {
        $scope.data.apBirthDateYYYY = $scope.selectedYear;
		$scope.data.apBirthDate = $scope.data.apBirthDateYYYY + '-' + ("00" + DataFactory.appData.applicant.apBirthDateMM).slice(-2) + '-' + ("00" + DataFactory.appData.applicant.apBirthDateDD).slice(-2);
		$rootScope.age = calculateAge($scope.data.apBirthDate);
		if (checkAgeOfMajority()) {
			DataFactory.setData($scope.data);
			ScrollFactory.showStep("applicantIncome");
			ScrollFactory.goToStep("applicantIncome");
			return true;
		}
    }

    $scope.prevStep = function () {
        ScrollFactory.showStep("birthdayDay");
        ScrollFactory.goToStep("birthdayDay");
    }

    $scope.prevYearEnabled = function () {
        var minDecade = (new Date().getFullYear() - 100).toString().substr(2, 1);
        return $scope.currentDecadeIndex > minDecade;
    }

    $scope.prevYear = function () {
        if ($scope.prevYearEnabled()) {
            $scope.currentDecadeIndex--;
        }
    }


    $scope.nextYearEnabled = function () {
        var maxDecade = 10;

        var today = new Date();
        var maxDOBYear = today.getFullYear() - 18;
        var m = (today.getMonth() + 1) - $scope.birthMM;
        if ((parseInt($scope.yearPrefix[$scope.currentDecadeIndex + 1] + "0") >= maxDOBYear) && (m < 0 || (m === 0 && $scope.birthDay > today.getDate()))) {
            return false;
        }
        if ($scope.currentDecadeIndex < maxDecade) {
            return true;
        }
    }


    $scope.nextYear = function () {
        if ($scope.nextYearEnabled()) {
            $scope.currentDecadeIndex++;
        }
    }

    function calculateAge(birthday) {
        birthday = new Date(birthday);
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }


    $scope.isYearVisible = function (year) {
        var today = new Date();
        var maxDOBYear = today.getFullYear() - 18;
        var minDOBYear = today.getFullYear() - 100;
        var year = parseInt(year);
        var m = (today.getMonth() + 1) - $scope.birthMM;


        if (((year > minDOBYear) || (year == minDOBYear && (m < 0 || (m === 0 && today.getDate() < $scope.birthDay)))) &&
            ((year < maxDOBYear) || (year == maxDOBYear && (m > 0 || (m === 0 && today.getDate() >= $scope.birthDay))))) {
            if ($scope.birthMM == "02" && $scope.birthDay == "29") {
                return leapYear(year);
            }
            else return true;
		}
        return false;
    }

    function leapYear(year) {
        year = parseInt(year);
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
	}

	function checkAgeOfMajority() {
		var p = $scope.data.apProvince;
		if ($scope.data.apBirthDate.length > 9 && $rootScope.age) {
			if (((p == "BC" || p == "NB" || p == "NL" || p == "NS" || p == "NT" || p == "NU" || p == "YT") && $rootScope.age < 19) || ((p == "AB" || p == "MB" || p == "ON" || p == "PE" || p == "QC" || p == "SK") && $rootScope.age < 18)) {
				$scope.majorityError = true;
				$timeout(function () {
					$scope.BirthdayYear.$setValidity('majority', false);
				});
				$rootScope.ga.errors.ageOfMajority();
				return false;
			}
			else {
				$scope.majorityError = false;
				$timeout(function () {
					$scope.BirthdayYear.$setValidity('majority', true);
				});
			}
		}
		return true;
	}
}
